import type { TransactionData } from "../../types/TransactionDataType";
import {
   Badge,
   MonoSmall,
   MonoUsername,
   TableHeadRow,
   TableRow,
   TableWrap
} from "../styles/TableStyle";

interface Props { data: TransactionData; onSelect?: (t: TransactionData[number]) => void; hideUsername?: boolean; hideRate?: boolean }

const TransactionList = ({ data, onSelect, hideUsername, hideRate }: Props) => {
   const getGridCols = () => {
      if (hideUsername && hideRate) return '1fr 1fr 1fr 1fr 1fr 1.2fr'
      if (hideUsername || hideRate) return '1fr 1fr 1fr 1fr 1fr 1fr 1.2fr'
      return '1fr 1.2fr 1fr 1fr 1fr 1fr 1fr 1.2fr'
   }

   return (
      <TableWrap>
         <TableHeadRow style={{ gridTemplateColumns: getGridCols() }}>
            <div>Trx ID</div>
            {!hideUsername && <div>Username</div>}
            <div>Type</div>
            <div>Asset</div>
            <div>Amount</div>
            {!hideRate && <div>Rate</div>}
            <div>Status</div>
            <div>Date</div>
         </TableHeadRow>

         {data.map(r => (
            <TableRow key={r.ref} className="hover:bg-[#FAFAFB] cursor-pointer transition-colors" onClick={() => onSelect?.(r)} style={{ gridTemplateColumns: getGridCols() }}>
               <MonoSmall>{r.ref}</MonoSmall>
               {!hideUsername && <MonoUsername>@{r.user.replace(/^@/, '')}</MonoUsername>}
               <div className='text-sm text-[#6D6D72]'>{r.type}</div>
               <div className='text-sm text-[#6D6D72]'>{r.asset}</div>
               <div className='text-sm text-[#101018]'>{r.amount}</div>
               {!hideRate && <div className='text-sm text-[#6D6D72]'>{r.rate}</div>}
               <div>
                  {r.status === 'Completed' && <Badge variant='success'>Completed</Badge>}
                  {r.status === 'Pending' && <Badge variant='pending'>Pending</Badge>}
                  {r.status === 'Failed' && <Badge variant='failed'>Failed</Badge>}
               </div>
               <div className="text-sm tracking-tight text-[#6D6D72]">{r.date}</div>
            </TableRow>
         ))}
      </TableWrap>
   );
}

export default TransactionList;